<template>
  <v-container class="main-container responsive-height create-investor-account-wrapper">
    <v-row>
      <v-col cols="12">
        <div class="middle-bar">
          <div class="titleName mb-1">
            <v-icon class="mr-2" color="#5F7692">mdi-bag-checked</v-icon>
            <span class="text--ash">Select Your Manager Firsts</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6" sm="6" lg="4" v-for="(manager, index) in managerLists" :key="manager.id">
        <v-card class="elevation-0 rounded-0 transition-method-card investor-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
          <div class="ribbon">
            <span>
              <template v-if="managerLists && managerLists.length > 0">
                <template v-if="index === 0"> Rank 1 </template>
                <template v-else-if="index === 1"> Rank 2 </template>
                <template v-else-if="index === 2"> Rank 3 </template>
              </template>
            </span>
          </div>
          <v-card flat class="profile-card rounded-0" :color="$vuetify.theme.dark ? '#172233' : 'transparent'">
            <div class="user-profile">
              <div class="profile-image">
                <v-badge avatar bordered overlap color="black accent-4" icon="mdi-star-outline">
                  <v-avatar size="59">
                    <v-img src="../../assets/avatar.png"></v-img>
                  </v-avatar>
                </v-badge>
              </div>
              <div class="profile-text">
                <span style="color: #02b58a; font-size: 14px">Manager
                  {{
                    manager.manager_type === 0
                      ? "(MAM)"
                      : manager.manager_type === 1
                        ? "(PAMM)"
                        : manager.manager_type === 2
                          ? "Copy trade"
                          : null
                  }}</span>
                <span style="font-size: 14px">{{
                  manager.st_username || "No Username"
                }}</span>
              </div>
            </div>
          </v-card>
          <v-card-actions>
            <div class="value">
              <span>Profit (all time)</span>
              <span>{{ manager?.totalProfit < 0 ? 0 : manager?.totalProfit?.toFixed() }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value">
              <span>Age (days)</span>
              <span>{{ manager.age }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
              <div>
                <apexChart width="100%" height="95px" type="line" :options="options"
                  :series="manager.totalProfit > 0 ? profitGain : profitLoss"></apexChart>
              </div>
            </v-sheet>
          </v-card-actions>

          <v-card-actions class="pb-0 pt-3">
            <v-btn :to="{
              path: '/manager-details',
              query: {
                id: manager.id,
              },
            }" tile outlined elevation="0" class="text-capitalize btn-account mr-2 ml-n1"
              color="greenMain">Details</v-btn>
            <v-btn :to="{
              path: '/create-investor-account-auth',
              query: {
                id: manager.id,
              },
            }" tile elevation="0" class="text-capitalize btn-account ml-0" color="greenMain">Invest</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { MAM__ACTIONS } from "@/store/action-types";

export default {
  data: () => ({
    options: {
      chart: {
        type: "line",
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        labels: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
      },
      grid: {
        show: false,
      },
      stroke: {
        width: 2,
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#3A648E"],
    },
    profitGain: [
      {
        name: "Profit",
        data: [2, 10, 50, 40, 60, 80, 95],
      },
    ],
    profitLoss: [
      {
        name: "Profit",
        data: [45, 52, 38, 45, 19, 23, 2],
      },
    ],
  }),
  computed: {
    ...mapState("mam", ["managerLists"]),
  },

  methods: {
    ...mapActions("mam", [MAM__ACTIONS.MANAGERLISTS]),
  },

  async mounted() {
    try {
      await this[MAM__ACTIONS.MANAGERLISTS]();
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
